const o = "音频",
  e = "黑色",
  t = "蓝色",
  a = "摄像头",
  n = "取消",
  c = "绘画",
  s = "GIF",
  r = "绿色",
  l = "图像",
  i = "链接",
  p = "位置",
  d = "橙色",
  h = "Padlet",
  m = "Poll",
  u = "紫色",
  g = "红色",
  S = "移除",
  T = "幻灯片",
  b = "某人",
  f = "Spotify",
  w = "上传",
  A = "视频",
  G = "网页",
  P = "白色",
  R = "黄色",
  C = "YouTube",
  I = {
    "‘%{postCustomPropertyName}’ button URL:": "%{postCustomPropertyName}' 按钮 URL：",
    "Add a caption": "添加标题",
    "Add a location": "添加一个地点",
    "Attach a link": "附上链接",
    "Attach another padlet": "附上另一个 padlet 看板",
    "Attachment loading progress": "附件加载进度",
    "Attachment upload progress": "附件上传进度",
    Audio: o,
    "Audio recorder": "录音机",
    Black: e,
    Blue: t,
    Camera: a,
    Cancel: n,
    "Cancel loading attachment": "取消加载附件",
    "Cancel uploading attachment": "取消上传附件",
    "Documents and Files": "文档和文件",
    Draw: c,
    "Draw something": "画一些东西",
    "Drop here to add it to this post": "点击此处将其添加到本帖",
    "Edit poll": "编辑投票",
    "Field must contain number": "字段必须包含数字",
    GIF: s,
    "Google Drive": "google drive",
    Green: r,
    "I can't draw": "我不能绘画",
    Image: l,
    "Image search": "图片搜索",
    Link: i,
    Location: p,
    "Make a poll": "创作 poll",
    "More attachment types": "更多附件类型",
    "No location": "无位置",
    "No section": "没有版块",
    "Open post color selection dialog": "打开帖子颜色选择对话框",
    "Open post location selection dialog": "打开帖子位置选择对话框",
    "Open post section selection dialog": "打开帖子选择对话框",
    Orange: d,
    Padlet: h,
    Poll: m,
    "Post attachment caption": "帖子附件说明",
    "Post subject": "帖子主题",
    Purple: u,
    "Record a video": "录制一个视频",
    "Record an audio": "录制一个音频",
    "Record your screen": "录制你的屏幕",
    Red: g,
    Remove: S,
    "Remove attachment from post": "从帖子中移除附件",
    "Remove poll from post": "删除帖子中的投票",
    "Remove tweet from post": "从帖子中删除推文",
    "Screen recorder": "屏幕录像机",
    "Search for a GIF": "搜索 GIF",
    "Search for an image": "搜索图片",
    "Search on Spotify": "在 Spotify 上搜索",
    "Search on the web": "在网站上搜索",
    "Search on YouTube": "在 YouTube 搜索",
    Slideshow: T,
    Someone: b,
    Spotify: f,
    "Take a photo": "拍一张照片",
    "The current post color is %{postColor}.": "目前帖子的颜色为 %{postColor}。",
    "The current post location is %{location}.": "目前的帖子位置为 %{location}。",
    "The current post section is %{sectionTitle}.": "目前的帖子版块为 %{sectionTitle}。",
    "This post has no location assigned.": "本帖子没有指派的位置。",
    "This post has no section assigned.": "本帖子没有指定专题。",
    "Tweet cannot be displayed": "推文无法显示",
    Upload: w,
    "Upload a file": "上传档案",
    "Upload from Google Drive": "从 Google Drive 上传",
    "Use AI Art Generator": "使用 AI Art Generator",
    Video: A,
    "Video recorder": "录像机",
    "Web search": "网页搜索",
    webpage: G,
    White: P,
    Yellow: R,
    YouTube: C
  };
export { o as Audio, e as Black, t as Blue, a as Camera, n as Cancel, c as Draw, s as GIF, r as Green, l as Image, i as Link, p as Location, d as Orange, h as Padlet, m as Poll, u as Purple, g as Red, S as Remove, T as Slideshow, b as Someone, f as Spotify, w as Upload, A as Video, P as White, R as Yellow, C as YouTube, I as default, G as webpage };